module.exports = __webpack_public_path__ + "images/orinoco.be0bdff805bedb217c50349554447070.jpg";